import { Checkbox } from '@1trading/react/components/ui/checkbox';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@1trading/react/components/ui/form';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import type { InstitutionFuturesReportingOrDefaults } from '@/features/institution/futures/reporting/schema';

const InstitutionFuturesReportingFieldsetEmir = () => {
  const form = useFormContext<InstitutionFuturesReportingOrDefaults>();
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <FormField
        control={form.control}
        name="emirUtiAcknowledgment"
        render={({ field }) => (
          <FormItem>
            <div className="flex flex-row items-center gap-4">
              <FormControl>
                <Checkbox checked={field.value} onCheckedChange={field.onChange} />
              </FormControl>
              <FormLabel>{t('institutionDetails.reporting.emirDetails.emirUtiAcknowledgment')}</FormLabel>
            </div>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="emirPostTradeRiskConfirmation"
        render={({ field }) => (
          <FormItem>
            <div className="flex flex-row items-center gap-4">
              <FormControl>
                <Checkbox checked={field.value} onCheckedChange={field.onChange} />
              </FormControl>
              <FormLabel>{t('institutionDetails.reporting.emirDetails.emirPostTradeRiskConfirmation')}</FormLabel>
            </div>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
InstitutionFuturesReportingFieldsetEmir.displayName = 'InstitutionFuturesReportingFieldsetEmir';

export { InstitutionFuturesReportingFieldsetEmir };
